import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "skill__level" }
const _hoisted_2 = { class: "skill__name" }
const _hoisted_3 = { class: "skill__experience" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "skill__dice-roll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RollSkillDice = _resolveComponent("RollSkillDice")!
  const _component_EditSkill = _resolveComponent("EditSkill")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", {
      class: "skill skill--clickable",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editMode = true))
    }, [
      _createElementVNode("aside", _hoisted_1, _toDisplayString(_ctx.skill.level), 1),
      _createElementVNode("h6", _hoisted_2, _toDisplayString(_ctx.$t(`skill__${_ctx.skill.name}`)), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.skill.experience) + " / " + _toDisplayString(_ctx.$options.rules.LEVEL_CUPS[_ctx.skill.level - 1]), 1),
      _createElementVNode("progress", {
        class: "skill__progress",
        max: "100",
        value: _ctx.experiencePercent
      }, _toDisplayString(_ctx.experiencePercent.toFixed()) + "% ", 9, _hoisted_4),
      _createElementVNode("span", _hoisted_5, [
        _createVNode(_component_RollSkillDice, { skill: _ctx.skill }, null, 8, ["skill"])
      ])
    ]),
    _createVNode(_component_ModalWindow, {
      modelValue: _ctx.editMode,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editMode) = $event)),
      title: _ctx.$t('edit-skill')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_EditSkill, {
          skill: _ctx.skill,
          onRemove: _ctx.remove,
          onUpdate: _cache[1] || (_cache[1] = (newSkill) => _ctx.update(newSkill)),
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editMode = false))
        }, null, 8, ["skill", "onRemove"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}